import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { CupcakeDropdownTriggerDirective } from '@ipreo/cupcake-components';
import { ItemGroup, SelectedValues, LabelGenerator } from '../../models/label';
import { MonitorFilter } from '../../models/monitor';

const ALL_LABEL = 'All';
const FILTER_UNAVAILABLE_MESSAGE = 'Filter unavailable for Sole-Managed deals';

@Component({
  selector: 'muni-gameday-filter-label',
  templateUrl: './filter-label.template.html',
  styleUrls: ['./filter-label.styles.scss'],
  standalone: false
})
export class FilterLabelComponent implements OnChanges {
  @Input()
  public highlightAll: boolean;
  @Input()
  public showingLabel: string;
  @Input()
  public allLabel: string = ALL_LABEL;
  @Input()
  public labelGenerator: LabelGenerator;
  @Input()
  public itemGroups: ItemGroup[];
  @Input()
  public values: SelectedValues;
  @Input()
  public isSoleManagedDeal: boolean;
  @Output()
  public filterChange = new EventEmitter<MonitorFilter>();

  @ViewChild('manualDropdown', { read: CupcakeDropdownTriggerDirective })
  manualDropdown: CupcakeDropdownTriggerDirective;

  public isAll = true;
  public selectedFilters: string = ALL_LABEL;

  public get tooltipMessage(): string {
    return this.isSoleManagedDeal ? FILTER_UNAVAILABLE_MESSAGE : '';
  }

  public onSelect(filter: MonitorFilter): void {
    if (this.isAll) {
      this.selectedFilters = this.allLabel;
    } else {
      this.selectedFilters = this.labelGenerator(this.itemGroups, filter);
    }
    this.hideDropdown();
    this.filterChange.emit(filter);
  }

  public toggleDropdown() {
    if (this.isSoleManagedDeal || !this.manualDropdown) {
      return;
    }
    if (this.manualDropdown.isExpanded()) {
      this.manualDropdown.collapse();
    } else {
      this.manualDropdown.expand();
    }
  }

  public hideDropdown(): void {
    if (this.manualDropdown && this.manualDropdown.isExpanded()) {
      this.manualDropdown.collapse();
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.values && ('values' in changes || 'itemGroups' in changes)) {
      this.isAll = !this.itemGroups.some((g: ItemGroup) => !!this.values[g.id]);
    }
  }
}
